import { render, staticRenderFns } from "./ProductStockAndPrice.vue?vue&type=template&id=73aa0800"
import script from "./ProductStockAndPrice.vue?vue&type=script&lang=js"
export * from "./ProductStockAndPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports